import { Card, Divider } from "@ctv/shared-core/src";
import { Children, Fragment, ReactNode } from "react";

type Props = {
  children?: ReactNode;
};

export default function ReviewStack(props: Props) {
  const children = Children.toArray(props.children);
  const lastIndex = children.length - 1;

  return (
    <Card>
      {children.map((child, index) => (
        <Fragment key={index}>
          {child}
          {index < lastIndex && <Divider />}
        </Fragment>
      ))}
    </Card>
  );
}
